import extend from '../extend';
import BrandingWidget from '../enums/BrandingWidget';

/**
 * Apply Branding.
 * takes config as param returns by settings branding values
 * used in Portal & Visitor-end
 */
export default class Branding {
    init(options, me) {
        this.widget = options.widget;
        // Brand config
        this.brand = { config: options.brandConfig };
        this.brandColor = this.brand.config.global.branding.brandColorCode;
        this.brandColorOpacity = `${this.brand.config.global.branding.brandColorCode}0F`; // Hex code 0F for 4% opacity

        // Apply Branding config
        this.applyBranding(this.widget);
        return this;
    }

    applyBranding(widget) {
        const me = this;
        switch (widget) {
            case BrandingWidget.RD_DOM:
                return (function () {
                    // Generic function for RD DOM, takes property of specfic widget, and set up the config.
                    me.overrideConfig(BrandingWidget.RD_DOM, 'rdChat');
                })();
            case BrandingWidget.RD_Invitation:
                return (function () {
                    // Generic function, takes property of specfic widget, and set up the config.
                    me.overrideConfig(BrandingWidget.RD_Invitation, 'rdInvitation');
                })();
            case BrandingWidget.RD_EP:
                return (function () {
                    // Generic function, takes property of specfic widget, and set up the config.
                    me.overrideConfig(BrandingWidget.RD_EP, 'exitPopupChat');
                })();
            case BrandingWidget.RD_PreChat:
                return (function () {
                    // Generic function, takes property of specfic widget, and set up the config.
                    me.overrideConfig(BrandingWidget.RD_DOM, 'rdThemeSettings');
                    me.overrideConfig(BrandingWidget.RD_PreChat, 'preChat');
                })();
            default:
        }
    }

    /**
     * / Generic function which override the config for branding
     * @param {any} widget
     * @param {any} propertyName
     */
    overrideConfig(widget, propertyName) {
        const me = this;
        // getting branding object
        const brandedConfig = me.getBrandingElements(widget);
        const backupConfig = JSON.parse(JSON.stringify(me.brand.config)); // Cloning object

        // overriding the orignal config with branding
        const config = extend(true, me.brand.config[propertyName], brandedConfig);
        backupConfig[propertyName] = config;
        me.brandedConfig = backupConfig;
    }

    getBrandedConfig() {
        return this.brandedConfig;
    }

    getBrandingElements(widget) {
        const me = this;
        // In case of branding Visitor Response text is static #3A3A3A
        const brandingStaticValues = {
            color: '#3A3A3A',
            backgroundColor: '#3A3A3A0F',
            whiteText: '#FFFFFF',
            darkOpacity: `#303030${80}`
        };
        switch (widget) {
            case BrandingWidget.RD_DOM:
                return {
                    enableBranding: true,
                    brandColor: me.brandColor,
                    brandColorOpacity: me.brandColorOpacity,
                    whiteText: brandingStaticValues.whiteText,
                    general: {
                        headerColor: me.brandColor,
                        disclaimerFont: {
                            color: me.brandColor
                        },
                        disclaimerBgColor: me.brandColorOpacity
                    },
                    messages: {
                        agentFont: {
                            color: me.brandColor
                        },
                        visitorFont: {
                            color: brandingStaticValues.color
                        },
                        visitorBgColor: brandingStaticValues.backgroundColor,
                        typingIndicatorDots: me.brandColor,
                        agentBgColor: me.brandColorOpacity
                    },
                    questionType: {
                        qTBorder: me.brandColor,
                        qTQuestion: me.brandColor,
                        qTButton: me.brandColor
                    }
                };
            case BrandingWidget.RD_Invitation:
                return {
                    general: {
                        backgroundColor: me.brandColor,
                        typingIndicator: me.brandColor,
                        btnClose: me.brandColorOpacity
                    },
                    rdIcon: {
                        dotColor: me.brandColor,
                        dotAnimationColor: me.brandColor
                    }
                };
            case BrandingWidget.RD_EP:
                return {
                    enableBranding: true,
                    general: {
                        leftBarBackground1Color: me.brandColor,
                        leftBarBackground2Color: me.brandColor,
                        btnClose: me.brandColorOpacity,
                        opacityBrandColor: me.brandColorOpacity,
                        disclaimerFont: {
                            color: me.brandColor
                        }
                    },
                    header: {
                        participantsFont: {
                            color: brandingStaticValues.whiteText
                        }
                    },
                    messages: {
                        agentFontField: {
                            color: me.brandColor
                        },
                        visitorFontField: {
                            color: brandingStaticValues.color
                        }
                    },
                    body: {
                        typingIndicatorFont: {
                            color: me.brandColor
                        }
                    },
                    sendButton: {
                        sendbuttonBackgroundColor: me.brandColor
                    }
                };
            case BrandingWidget.RD_PreChat:
                return {
                    enableBranding: true,
                    messagePopup: {
                        highLightColor: me.brandColor,
                        rdGlowTagColor: me.brandColor
                    }
                };
        }
    }
}
